import React from "react";
import { isEmpty, toString } from "lodash";

import { Layout as Static } from "./Layout";
import Async from "./Async";
import InputDisplay from "../InputDisplay";
import { getSelectedItem } from "../../../helpers/input";

export default function Dropdown(props) {
    const {
        prompt = "Please select...",
        input,
        meta,
        label = false,
        options = false,
        required = false,
        optGroupKey = false,
        disabled = false,
        allLabel = false,
        display = false,
        onSelect = () => { },
        ...otherProps
    } = props

    const { value, onChange, onBlur } = input;

    // Select value show on UI
    const selectValue = (list = [], loaded = false) => {
        if (allLabel !== false && value === "all") {
            return allLabel;
        }

        if (value === "") {
            return ((loaded === true && list.length === 0) || display === true) ? "-" : prompt;
        }

        let item = list.find(d => toString(d.id) === toString(value));
        return item ? item.name : prompt
    }

    // change the redux form value
    const onChangeHandler = (e, list) => {
        onBlur(e);
        if (!isEmpty(e)) {
            const value = e.target.value;
            onChange(value);
            if (typeof onSelect === "function") {
                onSelect(getSelectedItem({ value, prompt, disabled }, { list }))
            }
        }
    }

    if (display === true && (optGroupKey !== false || options !== false)) {
        return <InputDisplay input={{ value: selectValue(options, true) }} label={label} />
    }

    if (options !== false) {
        return (
            <Static
                list={options}
                input={input}
                meta={meta}
                prompt={prompt}
                label={label}
                required={required}
                disabled={disabled}
                onChangeHandler={onChangeHandler}
                selectValue={selectValue}
            />
        )
    }

    return (
        <Async
            meta={meta}
            label={label}
            input={input}
            prompt={prompt}
            display={display}
            required={required}
            disabled={disabled}
            allLabel={allLabel}
            selectValue={selectValue}
            onChangeHandler={onChangeHandler}
            {...otherProps}
        />
    )
}